import React from 'react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from "../ui/card";
import { Button } from "../ui/button";
import { Skeleton } from "../ui/skeleton";
import { Pencil, Trash2 } from "lucide-react";

const PredictionCards = ({ items, loading = false, onEdit, onDeleteRequest }) => {
    if (!loading && items.length === 0) return null;

    return (
        <div className="grid grid-cols-1 gap-4 md:hidden">
            {loading ? (
                Array.from({ length: 3 }).map((_, i) => (
                    <Card key={`skeleton-${i}`}>
                        <CardContent className="pt-6">
                            <Skeleton className="h-6 w-3/4 mb-2" />
                            <Skeleton className="h-4 w-1/2 mb-2" />
                            <Skeleton className="h-4 w-1/3" />
                        </CardContent>
                    </Card>
                ))
            ) : (
                items.map((item) => (
                    <Card key={item.prediction_id}>
                        <CardHeader>
                            <CardTitle>{item.stockSymbol || 'Stock non disponible'}</CardTitle>
                            <CardDescription>
                                {item.predicted_direction} — {item.predicted_time_frame}
                            </CardDescription>
                        </CardHeader>
                        <CardContent>
                            <p className="text-sm text-muted-foreground">Score: {item.score ?? 'N/A'}</p>
                        </CardContent>
                        <CardFooter className="flex justify-end gap-2">
                            <Button variant="outline" size="sm" onClick={() => onEdit(item)}>
                                <Pencil className="h-4 w-4 mr-1" /> Modifier
                            </Button>
                            <Button variant="destructive" size="sm" onClick={() => onDeleteRequest(item.prediction_id)}>
                                <Trash2 className="h-4 w-4 mr-1" /> Supprimer
                            </Button>
                        </CardFooter>
                    </Card>
                ))
            )}
        </div>
    );
};

export default PredictionCards;
